import type {SupportedLocales} from '@/lib/locale/locale'
import type {Product} from '@/models/productModel'

import createProductQueryOptions from './createProductQueryOptions'

export default async function preloadProduct(
  product: Pick<Product, 'retailer' | 'id'>,
  locale: SupportedLocales,
  queryClient: QueryClient,
) {
  return queryClient.ensureQueryData(createProductQueryOptions(locale, product, {preload: true}))
}
